import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTablePagination, DataTable } from 'components/common'
import { UsersResponse } from 'types/user'
import { useQuery } from 'hooks'
import { getColumns } from './utils'
import { getAllUsers } from 'utils/api/userManagement'
import { calculateOffset } from 'utils/helpers/pagination'

type Props = {
  isEditor: boolean
}

const UsersTable = ({ isEditor }: Props) => {
  const [userResponse, setUserResponse] = useState<UsersResponse | any>({})
  const [page, setPage] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const columns = useMemo(
    () => getColumns({ isEditor, page }),
    [isEditor, page],
  )

  // To get all user data
  const getUsers = async () => {
    setLoading(true)
    const { limit, page, search: SearchTerm } = getAllQueries()
    try {
      const { data } = await getAllUsers({
        limit: limit || 10,
        page: page || 1,
        search: SearchTerm,
      })
      setPage(calculateOffset(data))
      setUserResponse({ ...data })
    } catch (error) {
      setUserResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUsers()
  }, [search])

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : userResponse?.docs}
        identifier="_id"
      />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={userResponse?.page}
        totalPages={userResponse?.totalPages}
        hasNextPage={userResponse?.hasNextPage}
        hasPrevPage={userResponse?.hasPrevPage}
        limit={userResponse?.limit}
        nextPage={userResponse?.nextPage}
        prevPage={userResponse?.prevPage}
      />
    </>
  )
}

export default UsersTable
